
<p-messages [escape]="true" [value]="msgs"></p-messages>

<div class="form-group">
    <div class="row">
        <div class="col-md-6 col-xs-12">
            <div class="inputs">
                <input type="text" disabled id="opportunityName" [(ngModel)]="editOpportunityRow.opportunityName" />
                <label for="opportunityName">Opportunity Name</label>
            </div><!-- /.inputs -->
        </div><!-- /.col -->
        <div class="col-md-6 col-xs-12">
            <div class="inputs">
                <input type="text" disabled id="customerName" [(ngModel)]="editOpportunityRow.customer" />
                <label for="customerName">Customer</label>
            </div><!-- /.inputs -->
        </div><!-- /.col -->
    </div><!-- /.row -->
    <div class="row">
        <div class="col-md-6 col-xs-12">
            <div class="inputs">
                <input type="text" disabled id="sector" [(ngModel)]="editOpportunityRow.sector" />
                <label for="sector">Sector</label>
            </div><!-- /.inputs -->
        </div><!-- /.col -->
        <div class="col-md-6 col-xs-12">
            <div class="inputs">
                <input type="text" disabled id="type" [(ngModel)]="editOpportunityRow.type" />
                <label for="type">Type</label>
            </div><!-- /.inputs -->
        </div><!-- /.col -->
    </div><!-- /.row -->
    <div class="row">
        <div class="col-md-6 col-xs-12">
            <div class="inputs">
                <select name="status" required class="status" id="status" [(ngModel)]="updatedOpportunitiesDTO.status.statusId" >
                    <!-- <option id="-1" [ngValue]="null" selected default="yes" value="Select">Select</option> -->
                    <option *ngFor="let status of statusList | slice:4; let i = index" class="status?.odds"
                        [id]="status?.odds" [value]="status?.statusId">
                        {{status?.status}}
                    </option>
                </select>
                <label for="status"><span class="required" style="color:coral">*</span>Status</label>
            </div><!-- /.inputs -->
        </div><!-- /.col -->
    </div><!-- /.row -->
    <div class="row">
        <div class="inputs col-md-12 col-xs-12">
            <div class="group">
                <div class="collapse-title" (click)="ele2.class = ele2.class == 'showChildren' ? '' :  'showChildren'"
                    [ngClass]="{ hideChildren : ele2.class !== 'showChildren' }">
                    Attachments
                    <i class="collapse-icon fa" [ngClass]=" ele2.class !== 'showChildren' ? 'fa-plus' : 'fa-minus'"></i>
                </div>
                <div class="collapse in show" id="group-2" [ngClass]="{ hideChildren : ele2.class !== 'showChildren' }"
                    #ele2>
                    <div class="group-cont">
                        <div class="input-attachment">
                            <ul class="attaches" id="opportunityAttachments">
                                <div id="{{file.attachmentId}}" *ngFor="let file of attachmentFiles; let i = index">
                                    <li id="{{file.attachmentId}}" class="{{file.attachmentName}}"
                                        (click)="downloadAttachment($event)">
                                        {{file.attachmentName}}
                                        <div class="icon"><i class="la la-paperclip"></i></div>
                                    </li>
                                    <li style="background-color:white;border:none;">
                                        <div class="delete text-red">
                                            <i class="la la-trash" id="{{file.attachmentId}}" title="{{file.attachmentName}}"
                                                (click)="deleteAttachment($event);"></i>
                                        </div>
                                    </li>
                                </div>
                            </ul>
                            <div class="input" style="height: auto;">
                                <p-fileUpload name="demo[]" #fileUpload customUpload="true"
                                    (onUpload)="onUpload($event,fileUpload)"
                                    (uploadHandler)="onUpload($event, fileUpload)" multiple="multiple"
                                    maxFileSize="1000000">
                                </p-fileUpload>

                            </div>
                        </div><!-- /.input-attachment-->
                    </div><!-- /.group-cont -->
                </div><!-- /.collapse-->
            </div><!-- /.group -->
        </div><!-- /.inputs -->
    </div><!-- /.row -->
</div><!-- /.form-group -->
<!-- <div *ngIf="loading" class="spinner-container">
    <div class="sk-cube2 sk-cube"></div>
    <div class="sk-cube4 sk-cube"></div>
    <div class="sk-cube3 sk-cube"></div>
</div> -->
<div class="wizard-cotroles">
    <div class="form-actions">
      <button id="finish" (click)="onSubmit($event)">Finish</button>
    </div>
  </div>
